'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'jet-fighter';
var width = 576;
var height = 512;
var aliases = ["fighter-jet"];
var unicode = 'f0fb';
var svgPathData = 'M128 16c0-8.8 7.2-16 16-16L272 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-51.8 0 139.1 160 83.9 0c15.5 0 30.9 2.5 45.5 7.4l61.1 20.4C565.5 225 576 239.6 576 256s-10.5 31-26.1 36.2l-61.1 20.4c-14.7 4.9-30.1 7.4-45.5 7.4l-83.7 0-133.3 160 45.8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-160-25.4 0-43.3 43.3c-3 3-7.1 4.7-11.3 4.7l-64 0c-8.8 0-16-7.2-16-16L0 160c0-8.8 7.2-16 16-16l64 0c4.2 0 8.3 1.7 11.3 4.7l43.3 43.3 25.4 0 0-160-16 0c-8.8 0-16-7.2-16-16zm64 176L316.9 192 192 48.4 192 192zm0 128l0 151 125.8-151-125.8 0zM32 272l0 64 41.4 0 43.3-43.3c3-3 7.1-4.7 11.3-4.7l315.2 0c12 0 24-1.9 35.4-5.7l61.1-20.4c2.5-.8 4.2-3.2 4.2-5.9s-1.7-5-4.2-5.9l-61.1-20.4c-11.4-3.8-23.4-5.7-35.4-5.7L128 224c-4.2 0-8.3-1.7-11.3-4.7l-43.3-43.3-41.4 0 0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJetFighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;